import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

import MetaTags from 'react-meta-tags';
import Box from "@material-ui/core/Box";
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import GeneralStyles from '../../styles/GeneralStyles';
import axios from 'axios';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CircularProgress from '@material-ui/core/CircularProgress';


const useGeneralStyles = GeneralStyles;


function OurWorkContent(props) {

    const classesG = useGeneralStyles();
    const [ourWorkContent, setOurWorkContent] = useState(null);
    // const [cookies, setCookie] = useCookies([cookieName]);
    const [loading, setLoading] = useState(false);
    const matchMobile = useMediaQuery('(max-width:600px)');

    const { url } = useParams();

    useEffect(() => {
        setLoading(true);
        if (url !== '' && url !== undefined && url !== null) {
            axios
                .get(
                    `${process.env.REACT_APP_GATEWAY_END_POINT}/our-work-content/${url}`)
                .then((response) => {
                    setOurWorkContent(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(true);
                });
        } else {
            setLoading(false);
            const { history, location } = props;
            const { from } = location.state || {
                from: {
                    pathname: '/ourWork',
                },
            };
            history.push(from);
        }
    }, [url, props]);


    useEffect(() => {
        if (url !== '' && url !== undefined && url !== null && loading !== true) {
            var video2 = document.getElementById("video2");

            if (video2 !== null) {

                document.addEventListener("fullscreenchange", function () {
                    if (document.fullscreenElement === null && video2 !== null && video2 !== undefined) {
                        video2.style.display = "none";
                        video2.pause();
                    }
                }, false);
                document.addEventListener("mozfullscreenchange", function () {
                    if (document.mozFullScreen === false && video2 !== null && video2 !== undefined) {
                        video2.style.display = "none";
                        video2.pause();
                    }
                }, false);
                document.addEventListener("webkitfullscreenchange", function () {
                    if (document.webkitIsFullScreen === false && video2 !== null && video2 !== undefined) {
                        video2.style.display = "none";
                        video2.pause();
                    }
                }, false);


                document.addEventListener("webkitendfullscreense ", function () {
                    if (video2 !== null && video2 !== undefined) {
                        video2.style.display = "none";
                        video2.pause();
                    }
                }, false);

                video2.addEventListener('webkitendfullscreen', function () {
                    if (video2 !== null && video2 !== undefined) {
                        video2.style.display = "none";
                        video2.pause();
                    }
                }, false);
            }
        }

    }, [url, ourWorkContent, loading])

    const openFullscreen = () => {
        var video = document.getElementById("video2");
        video.style.display = "block";

        if (video.requestFullscreen) {
            video.pause();
            video.currentTime = 0;
            video.play();
            video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) { /* Safari */
            video.pause();
            video.currentTime = 0;
            video.play();
            video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) { /* IE11 */
            video.pause();
            video.currentTime = 0;
            video.play();
            video.msRequestFullscreen();
        } else if (video.webkitEnterFullscreen) { /* Mobile */
            video.pause();
            video.currentTime = 0;
            video.play();
            video.webkitEnterFullscreen();
        }
    }

    const replace = (param) => {
        var value = '';

        if (param !== '' && param !== null && param !== undefined) {
            value = param.replace(`${process.env.REACT_APP_GATEWAY_PATH_REPLACE}`, `${process.env.REACT_APP_GATEWAY_PATH_S3}`);
        }

        return value;
    }


    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                    <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {ourWorkContent === null || ourWorkContent === undefined ? '' : (
                        <React.Fragment>
                            <MetaTags>
                                <title>{ourWorkContent.Page_title}</title>
                                <meta name="description" content={ourWorkContent.Page_description} />
                            </MetaTags>
                            <div className={classesG.container}>

                                {ourWorkContent.Background_video === null ? '' : (
                                    <video src={matchMobile && ourWorkContent.Mobile_video !== null ? replace(ourWorkContent.Mobile_video.url) : replace(ourWorkContent.Desktop_video.url)}
                                        playsInline id='video2' className={classesG.videoBackground_section} style={{ display: 'none' }}>
                                    </video>
                                )}

                                <section className={classesG.section}>
                                    <div className={classesG.workExampleSectionBackgroundOp2}></div>
                                    <div className={classesG.workExamplesSecondSectionContent}>
                                        <div className={classesG.workExampleSectionBox}>
                                            <div className={classesG.workExampleFirstSectionText}>
                                                <h2>{ourWorkContent.Title}</h2>
                                                <h4 className={classesG.workH4_Black}>Regions</h4>
                                                <span className={classesG.workP_Black}>{ourWorkContent.Regions}</span>
                                                {ourWorkContent.Background_video === null ?
                                                    (
                                                        <img src={replace(ourWorkContent.Image.url)} alt={ourWorkContent.Image.name} />
                                                    ) : (
                                                        <div className={classesG.divVideo}>
                                                            <video src={replace(ourWorkContent.Background_video.url)}
                                                                playsInline autoPlay={'autoplay'} loop={true} muted id='video1'>
                                                            </video>
                                                            <PlayCircleOutlineIcon id={'playButton'} onClick={openFullscreen} />
                                                        </div>
                                                    )
                                                }


                                                <h5>{ourWorkContent.Challenge_title}</h5>
                                                <div dangerouslySetInnerHTML={{ __html: ourWorkContent.Challenge_text }} />

                                                <div className={classesG.workExampleContentSecondBlock}>
                                                    <div>
                                                        <img src={replace(ourWorkContent.Challenge_image.url)} alt={ourWorkContent.Challenge_image.name} />
                                                    </div>
                                                    <h3>{ourWorkContent.Challenge_headline}</h3>
                                                </div>

                                                <div>
                                                    <h5>{ourWorkContent.Background_title !== null ? ourWorkContent.Background_title : ''}</h5>
                                                    <div dangerouslySetInnerHTML={{ __html: ourWorkContent.Background_text !== null ? ourWorkContent.Background_text : '' }} />
                                                    <br />
                                                    <div style={ourWorkContent.Background_title !== null ? { marginTop: '0px' } : { marginTop: '16px' }} >
                                                        <img src={replace(ourWorkContent.Background_image.url)} alt={ourWorkContent.Background_image.name} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className={classesG.section}>
                                    <div className={classesG.workExamplesSecondSectionContent}>
                                        <div className={classesG.sectionBox}>
                                            <div className={classesG.workExampleSecondSectionImages}>
                                                <h4>{ourWorkContent.Finish_title}</h4>
                                                <div dangerouslySetInnerHTML={{ __html: ourWorkContent.Finish_text }} />
                                                <ul>
                                                    {ourWorkContent.Statistics === null || ourWorkContent.Statistics.length === 0 || ourWorkContent.Statistics.length === '' ? '' :
                                                        ourWorkContent.Statistics.sort((a, b) => a.Order - b.Order).map((items, i) => (
                                                            <li key={i}>
                                                                <h3>{items.Value}</h3>
                                                                <p>{items.Name}</p>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                                <div>
                                                    <img src={replace(ourWorkContent.Finish_image.url)} alt={ourWorkContent.Finish_image.name} />
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </section>

                                <Box mt={7}></Box>
                            </div>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default (OurWorkContent);